import { useRef, useState, useEffect, useMemo } from 'react'
import classnames from 'classnames'

import Auth from 'login-and-signup/'
import { withRouter } from 'i18n/utils'

import { isAuthVisibleSelector } from 'header/selectors'
import { closeAuth } from 'header/actions'
import NavBar from 'header/components//Navbar'
import 'header/styles/header.scss'

const SCROLL_THRESHOLD = 376

const Header = ({ isAuthVisible, closeAuth, location }) => {
    const [requiredScrollForSearch, setRequiredScrollForSearch] = useState(false)
    const containerRef = useRef(null)

    const isNavbarSearchActive = useMemo(() => {
        const isMap = location.pathname === '/map'
        const isHome = location.pathname === '/'
        return isMap || (isHome && requiredScrollForSearch)
    }, [requiredScrollForSearch, location.pathname])

    const handleScroll = () => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop

        if (scrollTop > SCROLL_THRESHOLD) {
            setRequiredScrollForSearch(true)
        } else if (requiredScrollForSearch) {
            setRequiredScrollForSearch(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <>
            <div
                ref={containerRef}
                className={classnames('header-and-navbar-container', isAuthVisible && 'auth-menu-opened')}>
                {isAuthVisible && (
                    <div className="header-wrapper">
                        <Auth closeAuth={closeAuth} />
                    </div>
                )}
                <NavBar isSearch={isNavbarSearchActive} />
            </div>
            <div style={{ height: 60 }} />
        </>
    )
}

const mapStateToProps = createStructuredSelector({
    isAuthVisible: isAuthVisibleSelector,
})
const mapDispatchToProps = { closeAuth }

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header)
